import React from 'react';
import {Grid} from '@material-ui/core';

import calcMuiSpacing from './calcMuiSpacing';

export default function CustomGrid({spacing, container, ...restProps}) {
    return (
        <Grid
            container={container}
            spacing={container ? calcMuiSpacing(spacing) : undefined}
            {...restProps}
        />
    )
}



// WEBPACK FOOTER //
// ./src/components/controls/grid/CustomGrid.jsx